export default "__VITE_ASSET__JVx6O8gO__"